import React from 'react';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp } from '@/lib/whatsapp';

const WhatsAppButton = ({
  message = 'Olá! Vim pelo site e quero agendar uma avaliação sem compromisso.',
}) => {
  const handleWhatsAppClick = () => {
    openWhatsApp({ section: 'floating_button', message });
  };

  return (
    <button
      type="button"
      onClick={handleWhatsAppClick}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] p-4 text-white shadow-[0_12px_40px_-8px_rgba(37,211,102,0.55)] ring-2 ring-white/25 transition hover:bg-[#20BD5A] hover:shadow-[0_16px_48px_-8px_rgba(37,211,102,0.65)] hover:ring-white/40 md:bottom-8 md:right-8"
      aria-label="Contato via WhatsApp"
    >
      <MessageCircle className="h-6 w-6" strokeWidth={1.75} />
      <span className="max-w-0 overflow-hidden whitespace-nowrap transition-all duration-300 group-hover:max-w-xs group-hover:pr-1">
        Fale conosco
      </span>
    </button>
  );
};

export default WhatsAppButton;
